<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="供应商" required>
						<supplier v-model="form.scoresupplierid" @change="supplierChange" />
					</el-form-item>
					<el-form-item label="供应商评级">
						<emun name="supplierlevel" v-model="form.supplierlevel" :readonly="true" />
					</el-form-item>
					<el-form-item label="当前积分">
						<el-input v-model="form.supplierscore" :readonly="true"></el-input>
					</el-form-item>
					<el-row :gutter="0" v-if="scoretype=='bonus'">
						<el-col :span="12">
							<el-form-item label="加分项">
								<el-row :gutter="0">
									<emun :emptyoption="false" :cascader="true" @change="supplierdeductChange"
										name="supplieradd" v-model="form.addoption" />
<!-- 									<el-input v-model="form.addoption"></el-input> -->
								</el-row>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="分值">
								<el-row :gutter="0">
									<el-input-number v-model="form.addscore" label="" :precision="2" :min="0"></el-input-number>
								</el-row>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="0" v-if="scoretype=='deduct'">
						<el-col :span="12">
							<el-form-item label="扣分项">
								<el-row :gutter="0">
									<emun :emptyoption="false" :cascader="true" @change="supplierdeductChange"
										name="supplierdeduct" v-model="form.deductoption" />
								</el-row>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="分值">
								<el-row :gutter="0">
									<el-input-number v-model="form.deductscore" label=""
										:precision="2" :max="0"></el-input-number>
								</el-row>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="变更说明" required>
						<el-input type="textarea" :rows="2" placeholder="" v-model="form.mark">
						</el-input>
					</el-form-item>
					<el-form-item label="辅助证明" required>
						<upload :formCreateInject="true" :value="form.file_img" ref="supplierscoreupload" />
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	import supplier from '@/components/formcomponents/common/select/supplier/select.vue'
	export default {
		mixins: [modalMixins],
		props: {
			scoretype: {
				default: () => {
					return 'deduct'
				}
			}
		},
		data() {
			return {
				suppliername: null,
				modal_title: '供应商打分',
				modal_width: 600,
				modal_height: 500,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}],
				form: {
					supplierlevel:null,
					supplierscore:null,
					scoresupplierid:null,
					addoption: null,
					addscore: 0,
					deductoption: null,
					deductscore: 0,
					mark: null,
					file_img:[]
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			supplierChange(e){
				console.log(e)
				if(e){
					let supplier = window.systemData.supplier.find((item)=>{
						return item.id == this.form.scoresupplierid
					})
					if(supplier){
						this.form.supplierlevel = supplier.supplierlevel
						this.form.supplierscore = supplier.score
					}else{
						this.form.supplierlevel = null
						this.form.supplierscore = null
					}
				}
			},
			initform(){
				this.form =  {
					supplierlevel:null,
					supplierscore:null,
					scoresupplierid:null,
					addoption: null,
					addscore: 0,
					deductoption: null,
					deductscore: 0,
					mark: null,
					file_img:[]
				}
			},
			modal_init() {
				this.initform()
			},
			submit() {
				this.loading = true
				this.form.file_img = this.$refs.supplierscoreupload.value
				if(!this.form.scoresupplierid){
					this.$message.error('供应商必填')
					return
				}
				if(!this.form.addoption && !this.form.deductoption){
					this.$message.error('【加分项】或【减分项】不能都为空')
					return
				}
				if(!this.form.mark){
					this.$message.error('变更说明必填')
					return
				}
				if(!this.form.file_img || !this.form.file_img.length){
					this.$message.error('辅助证明必填')
					return
				}
				//console.log(this.form.file_img)
				this.$api.supplierscore.updatescore(this.form).then(()=>{
					this.loading = false
					this.$emit('success')
					this.modal_cancel()
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
				//this.init()
			},
			reset() {
				//this.init()
			},
			supplierdeductChange(e) {
				if (e) {
					let deducttype = e[e.length - 1]
					this.$api.emunextend_supplierdeduct.get(deducttype).then((res) => {
						if (res) {
							this.form.deductscore = res.score
						}
					})
				}
				console.log(window.systemData)
			}
		},
		components: {
			upload,
			emun,
			supplier
		}
	}
</script>